import $ from 'jquery';
import 'jquery.easing';

import { LG_BREAKPOINT } from '../constants/constants';

const $window = $(window);
const $header = $('header.header');
const $headerNav = $('.header-nav');

// Search
// ------------------------------------------------------------------------ //
const $searchDropdownWrap = $('.search-dropdown');
const $searchDropdownBtn = $('.header-search-btn');
const $searchDropdown = $('.search-dropdown-form');
const $searchDropdownInput = $('.search-dropdown-input');

function openSearchDropdown() {
  $searchDropdown.css('height', 0);
  $searchDropdown.addClass('is-open');
  $searchDropdownBtn.attr('aria-expanded', true);
  $searchDropdownWrap.attr('aria-hidden', false);
  $searchDropdown.animate(
    {
      height: 83
    },
    300,
    'easeOutQuad',
    () => {
      $searchDropdown.attr('style', '');
      $searchDropdownInput.focus();
    }
  );
}

function closeSearchDropdown() {
  $searchDropdownBtn.attr('aria-expanded', false);
  $searchDropdownWrap.attr('aria-hidden', true);
  $searchDropdown.animate(
    {
      height: 0
    },
    300,
    'easeOutQuad',
    () => {
      $searchDropdown.removeClass('is-open');
      $searchDropdown.attr('style', '');
    }
  );
}

$searchDropdownBtn.click(e => {
  e.preventDefault();
  if ($searchDropdown.hasClass('is-open')) {
    closeSearchDropdown();
  } else {
    openSearchDropdown();
  }
});

// Mobile Nav
// ------------------------------------------------------------------------ //
$header.each((_, el) => {
  const $el = $(el);
  const $mobileNav = $el.find('.mobile-nav');
  const $menuBtn = $el.find('.header-menu-btn');
  const $items = $mobileNav.find('.mobile-nav-item');
  let heights = [$mobileNav.height()];
  let depth = 0;
  let windowWidth = 0;
  let isMobile = true;
  let isOpen = false;

  // Methods
  // ----------------------------------------- //
  function slideMenuTo(newDepth, newHeight) {
    $mobileNav.css({
      height: newHeight,
      left: `-${100 * newDepth}%`
    });
    heights.push(newHeight);
    depth = newDepth;
  }

  function slideBack() {
    depth -= 1;
    heights.pop();
    $mobileNav.css({
      height: heights[heights.length - 1],
      left: `-${100 * depth}%`
    });
  }

  function reset() {
    $mobileNav.attr('style', '');
    $items.removeClass('is-open');
    heights = [$mobileNav.height()];
    depth = 0;
  }

  // Track window size
  // ------------------------------------------------------------------------ //
  function checkWindowSize() {
    windowWidth = $window.width();

    if (windowWidth >= LG_BREAKPOINT) {
      if (isMobile) {
        isMobile = false;
        reset();
      }
    } else if (isMobile === false) {
      isMobile = true;
      reset();
    }
  }
  $window.resize(() => {
    checkWindowSize();
  });

  // Do this first time page loads
  checkWindowSize();

  // Recursive dig down and get index for each nav list
  // ----------------------------------------- //
  function bindLinks(depthIndex, $parent) {
    const $list = $parent.children('.mobile-nav-list');
    const $header = $parent
      .children('.mobile-nav-sub-header')
      .children('.mobile-nav-sub-header-link');
    const $childItems = $list.children('.mobile-nav-item');

    function makeCurrent(itemIndex, newHeight) {
      $childItems.removeClass('is-open');
      $($childItems[itemIndex]).addClass('is-open');
      slideMenuTo(depthIndex + 1, newHeight);
    }

    if ($header.length > 0) {
      $header.click(e => {
        e.preventDefault();
        slideBack();
      });
    }

    // Bind links
    $childItems.each((itemIndex, itemEl) => {
      const $item = $(itemEl);
      const $link = $item.children('.mobile-nav-link');
      const $subLinks = $item.children('.mobile-nav-sub');

      if ($subLinks.length > 0) {
        $link.click(e => {
          e.preventDefault();
          makeCurrent(itemIndex, $subLinks.height());
        });
        // Go deeper
        bindLinks(depthIndex + 1, $subLinks);
      }
    });
  }

  // Start at the top list
  bindLinks(0, $mobileNav);

  // Menu Btn
  // ------------------------------------------------------------------------ //
  $menuBtn.click(e => {
    e.preventDefault();
    if (isOpen) {
      $header.removeClass('is-open');
      reset();
      isOpen = false;
    } else {
      $header.addClass('is-open');
      reset();
      isOpen = true;
    }
  });
});

// Nav
// ------------------------------------------------------------------------ //
$headerNav.each((_, el) => {
  const $el = $(el);
  const $navItems = $el.find('.header-nav-item');

  // Nav Items
  // ------------------------------------------------------------------------ //
  $navItems.each((navItemIndex, navItemEl) => {
    const $navItem = $(navItemEl);
    const $dropdown = $navItem.find('.header-dropdown');

    function openDropDown() {
      closeSearchDropdown(); // breaks encapsulation, need better way.

      // Get height of dropdown
      const height = $dropdown.height();
      // Collapse the dropdown
      $dropdown.height(0);
      // Bring the dropdown forward
      $navItem.addClass('is-open');
      // WCAG
      $navItem.attr('aria-expanded', true);
      // Animate the height of the dropdown
      $dropdown.stop().animate(
        {
          height
        },
        300,
        'easeOutQuad',
        () => {
          // Clear out the inline styles so things work responsively
          $dropdown.attr('style', '');
          $dropdown.attr('aria-hidden', false);
        }
      );
    }

    function closeDropdown() {
      // Animate the height of the dropdown
      $dropdown.stop().animate(
        {
          height: 0
        },
        200,
        'easeOutQuad',
        () => {
          // Clear out the inline styles so things work responsively
          $dropdown.attr('style', '');
          // Move the dropdown to the back
          $dropdown.attr('aria-hidden', true);
          $navItem.removeClass('is-open');
          $navItem.attr('aria-expanded', false);
        }
      );
    }

    if ($dropdown.length > 0) {
      $navItem.hover(
        () => {
          openDropDown();
        },
        () => {
          closeDropdown();
        }
      );
    }
  });
});
